import axios from 'axios';
import { WorkOrderConfig } from '@/components/work-orders/types';

const API_URL = (import.meta.env.VITE_API_URL || 'http://localhost:5001').replace(/\/api$/, '');

export interface ApiWorkOrderSnapshot {
  id: string;
  workOrderInternalId: string;
  orderID: string;
  salesOrderId: string;
  orderNumber: string;
  customer: string;
  location: string;
  date: string;
  config: WorkOrderConfig;
  status: string;
  isBuilt: boolean;
  kittingComplete: boolean;
  fabricComplete: boolean;
  metalComplete: boolean;
  finalAssemblyComplete: boolean;
  isTKS0026: boolean;
  firstSeenAt: string;
  lastSeenAt: string;
  builtAt?: string;
  completedAt?: string;
}

export interface HistoryQuery {
  completed?: 'true' | 'false' | 'all';
  from?: string;
  to?: string;
  customer?: string;
  orderNumber?: string;
  location?: string;
  limit?: number;
}

export async function listWorkOrderHistory(
  token: string | null,
  query: HistoryQuery = {}
): Promise<ApiWorkOrderSnapshot[]> {
  const { data } = await axios.get(`${API_URL}/api/work-orders/history`, {
    params: query,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  return data;
}
